export default __webpack_public_path__ + "static/media/Snd_StartAtTop.c46fdae1.mp3";